module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_8017.7d12464d.png";